import { useQuery } from '@tanstack/react-query';
import { fetchProviders, fetchCertifications, fetchCertificationTopics } from '../api/certifications';

/** Fetches all cloud providers. Cached for 10 minutes. */
export function useProviders() {
  return useQuery({
    queryKey: ['providers'],
    queryFn: fetchProviders,
    staleTime: 10 * 60 * 1000,
  });
}

/** Fetches all certifications with provider info. Cached for 10 minutes. */
export function useCertifications() {
  return useQuery({
    queryKey: ['certifications'],
    queryFn: fetchCertifications,
    staleTime: 10 * 60 * 1000,
  });
}

/** Fetch topics for a specific certification code. */
export function useCertificationTopics(certCode: string | undefined) {
  return useQuery({
    queryKey: ['certification-topics', certCode],
    queryFn: () => fetchCertificationTopics(certCode!),
    enabled: !!certCode,
    staleTime: 10 * 60 * 1000,
  });
}
